import React, { Component } from 'react'
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary'
import InlineErrorFallback from './components/ErrorBoundary/InlineErrorFallback'
import { Route, Routes } from 'react-router-dom'
import { BrowserRouter as Router } from "react-router-dom";
import LoginPage from './pages/LoginPage'
import { observer, inject } from 'mobx-react'
import ProductsOverviewPage from './pages/ProductsOverviewPage'
import ProductDetailsPage from './pages/ProductDetailsPage'
import CategoryGroupExample from './pages/CategoryGroupExample'
import Page404 from './pages/Page404'
import PersonalSpace from './pages/PersonalSpacePage'
import PrivateRoute from './pages/PrivateRoute'
import ShoppingCartPage from './pages/ShoppingCartPage'
import ConfirmAddressPage from './pages/ConfirmAddressPage'
import OrderSuccessPage from './pages/OrderSuccessPage'
import ConfirmOrderPage from './pages/ConfirmOrderPage'
import { ThemeProvider } from 'styled-components'
import { themes } from './styles/themes'
import ScrollToTop from './components/Page/ScrollToTop';
import CostcenterPage from './pages/CostcenterPage'
import OrderOnStockPage from './pages/OrderOnStockPage'
import OrdersPage from './pages/OrdersPage'
import OrdersDetailPage from './pages/OrdersDetailPage'
import SupplierOrderDetailPage from './pages/SupplierOrderDetailPage'
import OrderTemplatesPage from './pages/OrderTemplatesPage'
import AddEmployeePage from './pages/Employee/AddEmployeePage'
import EmployeesPage from './pages/EmployeesPage'
import AdHocInventoryPage from './pages/LocalStorage/AdHocInventoryPage'
import GoodsReceiptPage from './pages/LocalStorage/GoodsReceiptPage'
import StoreGoodsReceiptPage from './pages/LocalStorage/GoodsReceipts/StoreGoodsReceiptPage'
import EditGoodsReceiptPage from './pages/LocalStorage/GoodsReceipts/EditGoodsReceiptPage'
import CreateGoodsReceiptPage from './pages/LocalStorage/GoodsReceipts/CreateGoodsReceiptPage'
import WithdrawalPage from './pages/LocalStorage/WithdrawalPage'
import PickingPreparationPage from './pages/LocalStorage/PickingProcess/PickingPreparationPage'
import PickingControlPage from './pages/LocalStorage/PickingProcess/PickingControlPage'
import ReturnsProcessingPage from './pages/LocalStorage/ReturnsProcessingPage'
import StoreReturnPage from './pages/LocalStorage/Returns/StoreReturnPage'
import EditEmployeePage from './pages/Employee/EditEmployeePage'
import EditHealthDataPage from './pages/Employee/EditHealthDataPage'
import EditAppointmentsPage from './pages/Employee/EditAppointmentsPage'
import EmployeesOrderTablePage from './pages/EmployeesOrderTablePage'
import ProductJobfunctionsPage from './pages/ProductJobfunctionsPage'
import ReportsPage from './pages/Administration/ReportsPage'
import AppointmentsAdministrationPage from './pages/Administration/AppointmentsAdministrationPage'
import SrmOrderAdministrationPage from './pages/Administration/SrmOrderAdministrationPage'
import AdministrationPage from './pages/Configuration/AdministrationPage'
import ConfigurationPage from './pages/Configuration/ConfigurationPage'
import OfficeAdministrationPage from './pages/Configuration/OfficeAdministrationPage'
import ActivitiesAdministrationPage from './pages/Configuration/ActivitiesAdministrationPage'
import CostCenterAdministrationPage from './pages/Configuration/CostCenterAdministrationPage'
import AppointmentPage from './pages/AppointmentPage'
import AppointmentTypesAdministrationPage from './pages/Configuration/AppointmentTypesAdministrationPage'
import CreateNewAppointmentTypePage from './pages/Configuration/CreateNewAppointmentTypePage'
import EditAppointmentTypePage from './pages/Configuration/EditAppointmentTypePage'
import CabinTypesAdministrationPage from './pages/Configuration/CabinTypesAdministrationPage'
import CreateNewCabinTypePage from './pages/Configuration/CreateNewCabinTypePage'
import EditCabinTypePage from './pages/Configuration/EditCabinTypePage'
import CreateNewOfficePage from './pages/Configuration/CreateNewOfficePage'
import CreateNewCostPage from './pages/Configuration/CreateNewCostPage'
import EditCostCenterPage from './pages/Configuration/EditCostCenterPage'
import EditOfficePage from './pages/Configuration/EditOfficePage'
import CostAccessRights from './components/Configuration/CostCenter/CostAccessRights'
import InterfaceCostCenterTree from './components/Configuration/CostCenter/InterfaceCostCenterTree'
import OfficeAccessRights from './components/Configuration/Office/OfficeAccessRights'
import CopyOfficePage from './pages/Configuration/CopyOfficePage'
import CopyCostPage from './pages/Configuration/CopyCostPage'
import TestDashboard from './pages/TestDashboard'
import CustomHtmlPage from './pages/CustomHtmlPage'
import BulkOrderPage from './pages/BulkOrderPage'
import InventoryPage from './pages/InventoryPage'
import InventoryDetailPage from './pages/InventoryDetailPage'
import InventoryHistoryPage from './pages/InventoryHistoryPage'
import InventoryActionPage from './pages/InventoryActionPage'
import InventoryActionPagePrint from './pages/InventoryActionPagePrint'

import SizeDetection from './pages/Administration/SizeDetection/SizeDetection'
import SizeDetectionByEmployee from './pages/Administration/SizeDetection/SizeDetectionByEmployee'
import CatalogProductDetailsPage from './pages/CatalogProductDetailsPage'
import CatalogProductsOverviewPage from './pages/CatalogProductsOverviewPage'
import InventoryReturnEmployeeSelect from './pages/InventoryReturnEmployeeSelect'
import InventoryReturnAssetSelect from './pages/InventoryReturnAssetSelect'
import Colors from './pages/Colors'
import InventoryImageUploadPage from './pages/InventoryImageUploadPage'
import CreateActivityPage from './pages/Configuration/CreateActivityPage'
import EditActivityPage from './pages/Configuration/EditActivityPage'
import EntitlementPhasesAdministrationPage from './pages/Configuration/EntitlementPhasesAdministrationPage'
import CreateEntitlementPhasePage from './pages/Configuration/CreateEntitlementPhasePage'
import EditEntitlementPhasePage from './pages/Configuration/EditEntitlementPhasePage'
import ContingentTemplatesAdministrationPage from './pages/Configuration/ContingentTemplatesAdministrationPage'
import CreateContingentTemplatePage from './pages/Configuration/CreateContingentTemplatePage'
import EditContingentTemplatePage from './pages/Configuration/EditContingentTemplatePage'
import CatalogsAdministrationPage from './pages/Configuration/CatalogsAdministrationPage';
import CreateCatalogPage from './pages/Configuration/CreateCatalogPage';
import EditCatalogPage from './pages/Configuration/EditCatalogPage';
import Testpage from './pages/Testpage';
import NewsAdministrationPage from './pages/Configuration/NewsAdministrationPage';
import PlaceholdersAdministrationPage from './pages/Configuration/PlaceholdersAdministrationPage';
import StdPointRunAdministrationPage from './pages/Configuration/StdPointRunAdministrationPage';
import ArticlesAdministrationPage from './pages/Configuration/Articles/ArticlesAdministrationPage';
import EditArticlePage from './pages/Configuration/Articles/EditArticlePage';
import CopyArticlePage from './pages/Configuration/Articles/CopyArticlePage';
import AssetTypesAdministrationPage from './pages/Configuration/AssetTypes/AssetTypesAdministrationPage'
import CreateAssetTypePage from './pages/Configuration/AssetTypes/CreateAssetTypePage'
import EditAssetTypePage from './pages/Configuration/AssetTypes/EditAssetTypePage'
import AssetGroupsAdministrationPage from './pages/Configuration/AssetGroups/AssetGroupsAdministrationPage'
import CreateAssetGroupPage from './pages/Configuration/AssetGroups/CreateAssetGroupPage'
import EditAssetGroupPage from './pages/Configuration/AssetGroups/EditAssetGroupPage'
import AssetsPage from './pages/Assets/AssetsPage'
import AddAssetPage from './pages/Assets/AddAssetPage'
import EditAssetPage from './pages/Assets/EditAssetPage'
import AssetsOrderTablePage from './pages/Assets/AssetsOrderTablePage'
import AssetsInventoryTablePage from './pages/Assets/AssetsInventoryTablePage.jsx'
import WashPage from './pages/Wash/WashPage';

const orderRoutes = [
  {
    path: '/products/:orderType',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Products failed to load' />}><ProductsOverviewPage /></ErrorBoundary>
  },
  {
    path: '/products/:orderType/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Products failed to load' />}><ProductsOverviewPage /></ErrorBoundary>
  },
  {
    path: '/products/:orderType/:shoppingBasketArticleId/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Product details failed to load' />}><ProductDetailsPage /></ErrorBoundary>

  },
  {
    path: '/order/:orderType/shoppingcart/:shoppingBasketId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Shopping cart failed to load' />}><ShoppingCartPage /></ErrorBoundary>

  },
  {
    path: '/order/:orderType/shoppingcart/:shoppingBasketId/confirmaddress',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Checkout failed to load' />}><ConfirmAddressPage /></ErrorBoundary>

  },
  {
    path: '/order/:orderType/shoppingcart/:shoppingBasketId/confirmaddress/confirmorder',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Order confirmation failed to load' />}><ConfirmOrderPage /></ErrorBoundary>

  },
  {
    key: 'ordersuccess',
    path: '/order/:orderType/shoppingcart/:shoppingBasketId/confirmaddress/confirmorder/ordersuccess',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Order success failed to load' />}><OrderSuccessPage /></ErrorBoundary>

  },
  {
    path: '/orderTemplates',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Order templates failed to load' />}><OrderTemplatesPage /></ErrorBoundary>

  },

]

const costcenterOrderRoutes = [
  {
    path: '/costcenter',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Cost center failed to load' />}><CostcenterPage /></ErrorBoundary>

  },
  {
    //used for CWS API from RLX News
    path: '/costCenterproducts/:shoppingBasketArticleId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Cost center failed to load' />}><CostcenterPage /></ErrorBoundary>

  },
  {
    path: '/costcenter/:costCenterId/costcenterproducts',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Products failed to load' />}><ProductsOverviewPage /></ErrorBoundary>

  },
  {
    path: '/costcenter/:costCenterId/costcenterproducts/:shoppingBasketArticleId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Product details failed to load' />}><ProductDetailsPage /></ErrorBoundary>
  },
  {
    path: '/costcenter/:costCenterId/shoppingcart/:shoppingBasketId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Shopping cart failed to load' />}><ShoppingCartPage /></ErrorBoundary>

  },
  {
    path: '/costcenter/:costCenterId/shoppingcart/:shoppingBasketId/confirmaddress',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Checkout failed to load' />}><ConfirmAddressPage /></ErrorBoundary>

  },
  {
    path: '/costcenter/:costCenterId/shoppingcart/:shoppingBasketId/confirmaddress/confirmorder',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Order confirmation failed to load' />}><ConfirmOrderPage /></ErrorBoundary>

  },
  {
    key: 'ordersuccess',
    path: '/costcenter/:costCenterId/shoppingcart/:shoppingBasketId/confirmaddress/confirmorder/ordersuccess',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Order success failed to load' />}><OrderSuccessPage /></ErrorBoundary>

  }
]
const storehouseOrderRoutes = [
  {
    path: '/storehouse',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Storehouse failed to load' />}><OrderOnStockPage /></ErrorBoundary>

  },
  {
    path: '/storehouse/:storeHouseId/:costCenterId/products',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Products failed to load' />}><ProductsOverviewPage /></ErrorBoundary>

  },
  {
    path: '/storehouse/:storeHouseId/:costCenterId/products/:shoppingBasketArticleId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Product details failed to load' />}><ProductDetailsPage /></ErrorBoundary>
  },
  {
    path: '/storehouse/:storeHouseId/:costCenterId/shoppingcart/:shoppingBasketId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Shopping cart failed to load' />}><ShoppingCartPage /></ErrorBoundary>

  },
  {
    path: '/storehouse/:storeHouseId/:costCenterId/shoppingcart/:shoppingBasketId/confirmaddress',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Checkout failed to load' />}><ConfirmAddressPage /></ErrorBoundary>

  },
  {
    path: '/storehouse/:storeHouseId/:costCenterId/shoppingcart/:shoppingBasketId/confirmaddress/confirmorder',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Order confirmation failed to load' />}><ConfirmOrderPage /></ErrorBoundary>

  },
  {
    key: 'ordersuccess',
    path: '/storehouse/:storeHouseId/:costCenterId/shoppingcart/:shoppingBasketId/confirmaddress/confirmorder/ordersuccess',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Order success failed to load' />}><OrderSuccessPage /></ErrorBoundary>

  }
]
const employeeRoutes = [
  {
    path: '/addemployee',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Add employee failed to load' />}><AddEmployeePage /></ErrorBoundary>

  },
  {
    path: '/editemployee/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit employee failed to load' />}><EditEmployeePage /></ErrorBoundary>

  },
  {
    path: '/editcheckups/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Health data failed to load' />}><EditHealthDataPage /></ErrorBoundary>

  },
  {
    path: '/editappointments/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Appointments failed to load' />}><EditAppointmentsPage /></ErrorBoundary>

  },
  {
    path: '/employees',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Employee list failed to load' />}><EmployeesPage /></ErrorBoundary>

  },
  {
    path: '/employeesordertable',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Employee orders failed to load' />}><EmployeesOrderTablePage /></ErrorBoundary>

  },
  {
    path: '/productjobfunction/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Job functions failed to load' />}><ProductJobfunctionsPage /></ErrorBoundary>

  },
  {
    path: '/appointment/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Appointment failed to load' />}><AppointmentPage /></ErrorBoundary>

  },
  {
    path: '/appointment/:employeeId/:appointmentId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Appointment failed to load' />}><AppointmentPage /></ErrorBoundary>

  }
]
const assetRoutes = [
  {
    path: '/assets',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Assets failed to load' />}><AssetsPage /></ErrorBoundary>

  },
  {
    path: '/addasset',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Add asset failed to load' />}><AddAssetPage /></ErrorBoundary>

  },
  {
    path: '/editasset/:assetId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit asset failed to load' />}><EditAssetPage /></ErrorBoundary>

  },
  {
    path: '/assetsordertable',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Asset orders failed to load' />}><AssetsOrderTablePage /></ErrorBoundary>

  },
  {
    path: '/assetsinventorytable',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Asset inventory failed to load' />}><AssetsInventoryTablePage /></ErrorBoundary>

  },
  {
    path: '/inventoryreturnassetselect/:assetId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Asset return failed to load' />}><InventoryReturnAssetSelect /></ErrorBoundary>

  },
  {
    path: '/inventoryreturnassetselect',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Asset return failed to load' />}><InventoryReturnAssetSelect /></ErrorBoundary>

  },
]
const localstorageRoutes = [
  {
    path: '/localstorage/adhocinventories',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Ad hoc inventory failed to load' />}><AdHocInventoryPage /></ErrorBoundary>

  },
  {
    path: '/localstorage/goodsreceipts',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Goods receipts failed to load' />}><GoodsReceiptPage /></ErrorBoundary>

  },
  {
    path: '/localstorage/goodsreceipts/:receiptId/store',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Store goods receipt failed to load' />}><StoreGoodsReceiptPage /></ErrorBoundary>

  },
  {
    path: '/localstorage/goodsreceipts/:receiptId/edit',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit goods receipt failed to load' />}><EditGoodsReceiptPage /></ErrorBoundary>

  },
  {
    path: '/localstorage/goodsreceipts/create',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Create goods receipt failed to load' />}><CreateGoodsReceiptPage /></ErrorBoundary>

  },
  {
    path: '/localstorage/returns',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Returns processing failed to load' />}><ReturnsProcessingPage /></ErrorBoundary>

  },
  {
    path: '/localstorage/returns/:returnId/store',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Store return failed to load' />}><StoreReturnPage /></ErrorBoundary>

  },
  {
    path: '/localstorage/withdrawals',
    component: <WithdrawalPage />

  },
  {
    path: '/localstorage/withdrawals/:soId/pickprep',
    component: <PickingPreparationPage />
  },
  {
    path: '/localstorage/withdrawals/:soId/pickcont',
    component: <PickingControlPage />
  },
  {
    path: '/wash',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Wash failed to load' />}><WashPage /></ErrorBoundary>

  },
]

let restrictedRoutes = [
  {
    path: '/',
    component: <TestDashboard />
  },
  {
    path: '/wysiwyg',
    component: <Testpage />
  },
  {
    path: '/inventory',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Inventory failed to load' />}><InventoryPage /></ErrorBoundary>

  },
  {
    path: '/inventory/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Inventory failed to load' />}><InventoryPage /></ErrorBoundary>

  },
  {
    path: '/inventoryDetails/:contingentArticleId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Inventory details failed to load' />}><InventoryDetailPage /></ErrorBoundary>

  },
  {
    path: '/inventoryDetails/:employeeId/:contingentArticleId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Inventory details failed to load' />}><InventoryDetailPage /></ErrorBoundary>

  },

  {
    path: '/inventoryHistory',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Inventory history failed to load' />}><InventoryHistoryPage /></ErrorBoundary>

  },
  {
    path: '/inventoryHistory/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Inventory history failed to load' />}><InventoryHistoryPage /></ErrorBoundary>

  },
  {
    path: '/inventoryAction/:actionType',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Inventory actions failed to load' />}><InventoryActionPage /></ErrorBoundary>

  },
  {
    path: '/inventoryAction/:actionType/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Inventory actions failed to load' />}><InventoryActionPage /></ErrorBoundary>

  },
  {
    path: '/inventoryAction/:actionType/:employeeId/:printcode',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Inventory print failed to load' />}><InventoryActionPagePrint /></ErrorBoundary>

  },
  //für backToOrgaunit und backToEmployee
  //from logged in user to someone else
  {
    path: '/inventoryreturnto/:actionType/:targetId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Inventory actions failed to load' />}><InventoryActionPage /></ErrorBoundary>

  },
  //from someone else to someone else
  {
    path: '/inventoryreturnto/:actionType/:employeeId/:targetId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Inventory actions failed to load' />}><InventoryActionPage /></ErrorBoundary>

  },
  {
    path: '/inventoryBookings/imageUpload',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Image upload failed to load' />}><InventoryImageUploadPage /></ErrorBoundary>

  },
  {
    path: '/inventoryBookings/imageUpload/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Image upload failed to load' />}><InventoryImageUploadPage /></ErrorBoundary>

  },
  {
    path: '/inventoryreturnemployeeselect/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Inventory return failed to load' />}><InventoryReturnEmployeeSelect /></ErrorBoundary>

  },
  {
    path: '/inventoryreturnemployeeselect',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Inventory return failed to load' />}><InventoryReturnEmployeeSelect /></ErrorBoundary>

  },

  {
    path: '/personalSpace',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Personal space failed to load' />}><PersonalSpace /></ErrorBoundary>

  },
  {
    path: '/categorygroup-example',
    component: <CategoryGroupExample />

  },
  {
    path: '/orders',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Orders failed to load' />}><OrdersPage /></ErrorBoundary>

  },
  {
    path: '/employee-orders/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Orders failed to load' />}><OrdersPage /></ErrorBoundary>

  },
  {
    path: '/asset-orders/:assetId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Orders failed to load' />}><OrdersPage /></ErrorBoundary>

  },
  {
    path: '/orders/:incomingOrderId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Order details failed to load' />}><OrdersDetailPage /></ErrorBoundary>

  },
  {
    path: '/orders/:incomingOrderId/supplierOrder/:supplierOrderId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Supplier order failed to load' />}><SupplierOrderDetailPage /></ErrorBoundary>

  },
  {
    path: '/orders/:incomingOrderId/:print',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Order details failed to load' />}><OrdersDetailPage /></ErrorBoundary>

  },
  {
    path: '/reports',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Reports failed to load' />}><ReportsPage /></ErrorBoundary>

  },
  {
    path: '/appointmentsadministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Appointments administration failed to load' />}><AppointmentsAdministrationPage /></ErrorBoundary>

  },
  {
    path: '/newsAdministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='News administration failed to load' />}><NewsAdministrationPage /></ErrorBoundary>

  },
  {
    path: '/srmorderadministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='SRM order administration failed to load' />}><SrmOrderAdministrationPage /></ErrorBoundary>

  },
  {
    path: '/colors',
    component: <Colors />

  },
  {
    path: '/articleCatalog/article/:articleId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Article catalog failed to load' />}><CatalogProductDetailsPage /></ErrorBoundary>

  },
  {
    path: '/articleCatalog',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Article catalog failed to load' />}><CatalogProductsOverviewPage /></ErrorBoundary>

  }
]

const administrationRoutes = [
  {
    path: '/administration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Administration failed to load' />}><AdministrationPage /></ErrorBoundary>

  },
  {
    path: '/configuration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Configuration failed to load' />}><ConfigurationPage /></ErrorBoundary>

  },
  {
    path: '/activitiesAdministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Activities administration failed to load' />}><ActivitiesAdministrationPage /></ErrorBoundary>

  },
  {
    path: '/activitiesAdministration/create',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Create activity failed to load' />}><CreateActivityPage /></ErrorBoundary>

  },
  {
    path: '/activitiesAdministration/edit/:activityId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit activity failed to load' />}><EditActivityPage /></ErrorBoundary>

  },
  {
    path: '/contingentTemplatesAdministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Contingent templates failed to load' />}><ContingentTemplatesAdministrationPage /></ErrorBoundary>

  },
  {
    path: '/contingentTemplatesAdministration/createContingent',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Create contingent template failed to load' />}><CreateContingentTemplatePage /></ErrorBoundary>

  },
  {
    path: '/contingentTemplatesAdministration/editContingent/:contingentTemplateId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit contingent template failed to load' />}><EditContingentTemplatePage /></ErrorBoundary>

  },
  {
    path: '/entitlementPhasesAdministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Entitlement phases failed to load' />}><EntitlementPhasesAdministrationPage /></ErrorBoundary>

  },
  {
    path: '/entitlementPhasesAdministration/create',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Create entitlement phase failed to load' />}><CreateEntitlementPhasePage /></ErrorBoundary>

  },
  {
    path: '/entitlementPhasesAdministration/edit/:entitlementPhaseId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit entitlement phase failed to load' />}><EditEntitlementPhasePage /></ErrorBoundary>

  },
  {
    path: '/officeadministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Office administration failed to load' />}><OfficeAdministrationPage /></ErrorBoundary>

  },
  {
    path: '/officeadministration/create',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Create office failed to load' />}><CreateNewOfficePage /></ErrorBoundary>

  },
  {
    path: '/officeadministration/create/access-rights',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Office access rights failed to load' />}><OfficeAccessRights /></ErrorBoundary>

  },
  {
    path: '/officeadministration/edit/:officeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit office failed to load' />}><EditOfficePage /></ErrorBoundary>

  },
  {
    path: '/officeadministration/copy/:officeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Copy office failed to load' />}><CopyOfficePage /></ErrorBoundary>

  },
  {
    path: '/stdPointRunAdministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Administration failed to load' />}><StdPointRunAdministrationPage /></ErrorBoundary>

  },
  {
    path: '/costcenteradministration/create',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Create cost center failed to load' />}><CreateNewCostPage /></ErrorBoundary>

  },

  {
    path: '/costcenteradministration/edit/:costCenterId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit cost center failed to load' />}><EditCostCenterPage /></ErrorBoundary>

  },
  {
    path: '/costcenteradministration/copy/:costCenterId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Copy cost center failed to load' />}><CopyCostPage /></ErrorBoundary>

  },
  {
    path: '/costcenteradministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Cost center administration failed to load' />}><CostCenterAdministrationPage /></ErrorBoundary>

  },
  {
    path: '/costcenteradministration/create/access-rights',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Cost center access rights failed to load' />}><CostAccessRights /></ErrorBoundary>

  },
  {
    path: '/costcenteradministration/create/interfaces',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Cost center interfaces failed to load' />}><InterfaceCostCenterTree /></ErrorBoundary>

  },
  {
    path: '/placeholdersAdministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Placeholders administration failed to load' />}><PlaceholdersAdministrationPage /></ErrorBoundary>

  },
  {
    path: '/appointmenttypes',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Appointment types failed to load' />}><AppointmentTypesAdministrationPage /></ErrorBoundary>

  },
  {
    path: '/appointmenttypes/create',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Create appointment type failed to load' />}><CreateNewAppointmentTypePage /></ErrorBoundary>

  },
  {
    path: '/appointmenttypes/edit/:appointmentTypeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit appointment type failed to load' />}><EditAppointmentTypePage /></ErrorBoundary>

  },
  {
    path: '/cabintypes',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Cabin types failed to load' />}><CabinTypesAdministrationPage /></ErrorBoundary>

  },
  {
    path: '/cabintypes/create',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Create cabin type failed to load' />}><CreateNewCabinTypePage /></ErrorBoundary>

  },
  {
    path: '/cabintypes/edit/:cabinTypeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit cabin type failed to load' />}><EditCabinTypePage /></ErrorBoundary>

  },
  {
    path: '/catalogsAdministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Catalogs administration failed to load' />}><CatalogsAdministrationPage /></ErrorBoundary>
  },
  {
    path: '/catalogsAdministration/createCatalog',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Create catalog failed to load' />}><CreateCatalogPage /></ErrorBoundary>

  },
  {
    path: '/catalogsAdministration/editCatalog/:catalogId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit catalog failed to load' />}><EditCatalogPage /></ErrorBoundary>

  },
  //NEW ROUTES FOR SIZE DETECTION FEATURE
  {
    path: '/sizeDetection',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Size detection failed to load' />}><SizeDetection /></ErrorBoundary>

  },
  {
    path: '/sizeDetection/:employeeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Size detection failed to load' />}><SizeDetectionByEmployee /></ErrorBoundary>

  },
  {
    path: '/articlesAdministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Articles administration failed to load' />}><ArticlesAdministrationPage /></ErrorBoundary>
  },
  {
    path: '/articlesAdministration/editArticle/:articleId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit article failed to load' />}><EditArticlePage /></ErrorBoundary>
  },
  {
    path: '/articlesAdministration/copyArticle/:articleId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Copy article failed to load' />}><CopyArticlePage /></ErrorBoundary>
  },
  {
    path: '/assetTypesAdministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Asset types administration failed to load' />}><AssetTypesAdministrationPage /></ErrorBoundary>
  },
  {
    path: '/assetTypesAdministration/create',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Create asset type failed to load' />}><CreateAssetTypePage /></ErrorBoundary>

  },
  {
    path: '/assetTypesAdministration/edit/:assetTypeId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit asset type failed to load' />}><EditAssetTypePage /></ErrorBoundary>
  },
  {
    path: '/assetGroupsAdministration',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Asset groups administration failed to load' />}><AssetGroupsAdministrationPage /></ErrorBoundary>
  },
  {
    path: '/assetGroupsAdministration/create',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Create asset group failed to load' />}><CreateAssetGroupPage /></ErrorBoundary>

  },
  {
    path: '/assetGroupsAdministration/edit/:assetGroupId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Edit asset group failed to load' />}><EditAssetGroupPage /></ErrorBoundary>
  },
]

const bulkOrderRoutes = [
  {
    path: '/bulkorder',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Bulk order failed to load' />}><BulkOrderPage /></ErrorBoundary>

  }
]

const cwsMenuRoutes = [
  {
    path: '/custom-html/:menuId',
    component: <ErrorBoundary fallbackRender={(props) => <InlineErrorFallback {...props} title='Page failed to load' />}><CustomHtmlPage /></ErrorBoundary>

  }
]
export const appRoutes = restrictedRoutes
  .concat(orderRoutes)
  .concat(costcenterOrderRoutes)
  .concat(storehouseOrderRoutes)
  .concat(employeeRoutes)
  .concat(assetRoutes)
  .concat(administrationRoutes)
  .concat(cwsMenuRoutes)
  .concat(bulkOrderRoutes)
  .concat(localstorageRoutes)


class LogixRoutes extends Component {
  constructor(props) {
    super(props)
    if (!props.uiStore.reloading) {
      //reset LoginStore.isUserLoggedIn and LoginStore.apiAccessToken
      props.loginStore.setApiAccessToken(sessionStorage.getItem('apiAccessToken') ? JSON.parse(sessionStorage.getItem('apiAccessToken')) : null)
    }
  }
  //todo move SSOLogin before ThemeInit. best case inside Router but then basename can not be what it is atm
  render() {
    const { uiStore } = this.props
    const urlPrefix = `${'/' + uiStore.theme + '/' + uiStore.language + '/'}`
    const theme = themes[uiStore.theme]

    if (this.props.uiStore.reloading) {
      return ''
    }
    return (
      <Router basename={process.env.PUBLIC_URL + urlPrefix}>
        <ThemeProvider theme={theme}>
          <ScrollToTop >
            <Routes >
              {/* Login routes */}
              {appRoutes.map(obj => <Route path={obj.path} key={obj.path} element={<PrivateRoute>{React.cloneElement(obj.component, { key: obj.path })}</PrivateRoute>} />)}
              {['/login', '/password-reset', '/sign-up'].map(path => <Route path={path} key={path} element={<LoginPage />} />)}
              {/* Fallback 404 Page */}
              <Route path='*' element={<Page404 />} />
            </Routes>
          </ScrollToTop >
        </ThemeProvider>
      </Router >
    )
  }
}

export default inject('uiStore', 'loginStore')(observer(LogixRoutes));
